/** Espelha SituacaoMovimentacaoEnum (API.Financas): situação de conciliação da movimentação. */
export enum SituacaoMovimentacaoEnum {
    Conciliado = 1,
    NaoConciliado = 2,
}
